import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4 8.25l7.51 1-7.5-3.22zm.01 9.72l7.5-3.22-7.51 1z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3zM4 8.25V6.03l7.51 3.22-7.51-1zm.01 9.72v-2.22l7.51-1-7.51 3.22z"
})), 'SendTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SendTwoTone.js
// module id = 5972
// module chunks = 2